import { useCallback, useEffect, useState } from 'react';

export interface UseDialogOptions {
  autoUpdate?: boolean;
}

export const useDialog = (
  defaultState = false,
  { autoUpdate = false }: UseDialogOptions = {},
) => {
  const [isOpened, setIsOpened] = useState(defaultState);
  const [isHidden, setIsHidden] = useState(false);

  const onClose = useCallback(() => {
    setIsOpened(false);
  }, []);

  const onOpen = useCallback(() => {
    setIsOpened(true);
  }, []);

  const handleHide = useCallback(() => setIsHidden(true), []);
  const handleShow = useCallback(() => setIsHidden(false), []);

  useEffect(() => {
    if (autoUpdate) {
      setIsOpened(defaultState);
    }
    // only defaultState should be tracked
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultState]);

  return {
    handleHide,
    handleShow,
    isHidden,
    isOpened,
    onClose,
    onOpen,
  };
};
